import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=4aec5eef&scoped=true&"
import script from "./formBox.vue?vue&type=script&lang=js&"
export * from "./formBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec5eef",
  null
  
)

export default component.exports